import { useMemo } from 'react';
import { useQuery, useQueryClient } from 'react-query';
import { LoadingStatus } from './constants';

const getLoadingStatus = (status, data) => {
    switch (status) {
        case 'loading':
            return LoadingStatus.LOADING;
        case 'error':
            return LoadingStatus.ERROR;
        case 'success':
            return data && data.length > 0 ? LoadingStatus.SUCCESS : LoadingStatus.EMPTY;
        default:
            return LoadingStatus.LOADING;
    }
};

export const useRestStore = (queryKey, actions, options) => {
    const client = useQueryClient();
    const { data, status } = useQuery(queryKey, () => actions.get(), options);

    return useMemo(() => {
        return {
            update: (id, item) => {
                return actions.update(id, item).then(res => {
                    client.setQueryData(queryKey, old => {
                        return old.map(it => (it.id === res.id ? res : it));
                    });

                    return res;
                });
            },
            getById: id => {
                return data?.find(it => it.id === id);
            },
            data: data || [],
            status: getLoadingStatus(status, data),
            create: data => {
                return actions.create(data).then(res => {
                    client.setQueryData(queryKey, old => {
                        return [...(old || []), res];
                    });

                    return res;
                });
            },
            delete: id => {
                return actions.delete(id).then(() => {
                    client.setQueryData(queryKey, old => {
                        return old.filter(it => it.id !== id);
                    });
                });
            }
        };
    }, [data, client, queryKey, actions, status]);
};
